import { api } from 'api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFaqRemove = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id) => api.faq.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faqList'] })

      toaster.create({
        type: 'success',
        title: 'Элемент удален успешно',
      })
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при попытке удален элемент',
        description: err.message,
      })
    },
  })
}
